import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import {
  selectAuthIsRegistration,
  selectIsAuthenticated,
  selectIsLoginSuccessDone,
} from '@/store/selectors/authSelectors';
import { selectLoginBonuses, selectWelcomeOfferBonuses } from '@/store/bonuses/selectors';
import { useModal } from '@/features/modal/useModal';
import { MODALS } from '@/features/modal/types';
import { useRestrictedMode } from '@/hooks/useRestrictedMode';

export function useWelcomeOffersDisplay(): void {
  const isRegistration = useSelector(selectAuthIsRegistration);
  const welcomeOfferAvailableBonusesRegistration = useSelector(selectWelcomeOfferBonuses);
  const loginReminderBonuses = useSelector(selectLoginBonuses);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const isLoginSuccessDone = useSelector(selectIsLoginSuccessDone);
  const isAuthenticatedAndLoaded = isAuthenticated && isLoginSuccessDone;
  const { openModal } = useModal();
  const isRestricted = useRestrictedMode();
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      setShown(false);
    }
  }, [isAuthenticated]);
  useEffect(() => {
    // We want to show the welcome offers modal only:
    // 1. post registration (login + registration only offers)
    // 2. post login
    // Restricted-mode users (Alberta on ROC) get no bonus offers.
    if (isAuthenticatedAndLoaded && !shown && !isRestricted) {
      if (isRegistration) {
        if (welcomeOfferAvailableBonusesRegistration.length > 0) {
          openModal(MODALS.WELCOME_OFFERS, { bonuses: welcomeOfferAvailableBonusesRegistration });
          setShown(true);
        }
      } else {
        if (loginReminderBonuses.length > 0) {
          openModal(MODALS.WELCOME_OFFERS, { bonuses: loginReminderBonuses });
          setShown(true);
        }
      }
    }
  }, [
    isRegistration,
    loginReminderBonuses,
    welcomeOfferAvailableBonusesRegistration,
    isAuthenticatedAndLoaded,
    isRestricted,
  ]);
}
